import { Outlet, useLocation } from "react-router-dom";
import { Suspense, useEffect } from "react";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { CookieBanner } from "@/components/layout/CookieBanner";
import { useSiteState } from "@/context/SiteContext";
import { PageState } from "@/components/PageState";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => document.getElementById(decodeURIComponent(hash.slice(1)))?.scrollIntoView(), 350);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
    return undefined;
  }, [pathname, hash]);
  return null;
};

export default function Layout() {
  const { data, loading, error } = useSiteState();
  if (!data) {
    return (
      <div className="container-site py-24">
        <PageState loading={loading} error={error} message="İçerik hazırlanıyor, lütfen birkaç dakika sonra tekrar deneyin." />
      </div>
    );
  }
  return (
    <div className="flex min-h-screen flex-col bg-white">
      <a href="#icerik" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:rounded focus:bg-navy focus:px-4 focus:py-2 focus:text-white" data-testid="skip-to-content-link">
        İçeriğe geç
      </a>
      <ScrollManager />
      <Header />
      <main id="icerik" className="min-h-screen flex-1" tabIndex={-1}>
        <Suspense fallback={<div className="container-site"><PageState loading /></div>}>
          <Outlet />
        </Suspense>
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
